export default __webpack_public_path__ + "static/leg_img_4-ea64d9a6dcf2e6eb3fefca1ec1ab2abe.png";